<template>
  <div class="reports-analytics">
    <!-- 🎯 ANALYTICS OVERVIEW -->
    <v-card elevation="4" class="mb-6 analytics-header">
      <v-card-text class="pa-6">
        <div class="mb-4">
          <h2 class="text-h4 text-primary mb-2">
            <v-icon size="32" class="mr-3">mdi-chart-box</v-icon>
            Analytics de Reportes
          </h2>
        </div>

        <!--
          P13-V5A-R5 · RETIRED. Las tres tarjetas de "insights" eran un array literal: afirmaban
          que el reporte "Dashboard Ejecutivo" podía optimizarse un 40 %, que los usuarios
          prefieren PDF entre las 9 y las 11 AM, y que se preveía un 60 % más de reportes de
          campo el trimestre siguiente, cada una con su "impacto" (+40 % velocidad, +25 %
          adopción, +60 % demanda) y un botón "Aplicar" que no ejecutaba nada. Ningún motor
          producía esos análisis: R4 eliminó del backend los montajes /api/ai y /api/ml, y
          /api/analytics/ai-predictions responde 501. Los botones "Actualizar" y "Exportar" de
          este encabezado sólo escribían en la consola; exportar un análisis inexistente es la
          misma falsedad en otro formato, así que se retiran con él. Una tarjeta sin productor se
          retira, no se rellena.
        -->
        <div data-testid="reports-analytics-insights-retired">
          <v-alert type="info" variant="tonal" density="compact">
            Estos análisis no tienen un productor canónico y fueron retirados en P13-V5A-R5. La
            generación de insights automáticos no está disponible.
          </v-alert>
        </div>
      </v-card-text>
    </v-card>

    <!-- 📊 PERFORMANCE METRICS -->
    <v-row class="mb-6">
      <v-col cols="12" lg="8">
        <v-card elevation="4">
          <v-card-title class="pa-6">
            <v-icon color="primary" class="mr-3">mdi-speedometer</v-icon>
            <span class="text-h5">Performance de Reportes</span>
          </v-card-title>

          <!--
            P13-V5A-R5 · RETIRED. El gráfico dibujaba dos series constantes escritas en el
            archivo: "Tiempo de Respuesta (ms)" [1200, 800, 2100, 3200, 2800, 1900, 1400] y
            "Reportes Generados" [5, 2, 25, 45, 38, 22, 12], sobre etiquetas horarias fijas. El
            selector 24H/7D/30D/90D redibujaba siempre esos mismos siete puntos, de modo que
            cambiar el período no cambiaba nada. No existe endpoint que mida el rendimiento de
            la generación de reportes, y este componente no emitía ninguna petición.
          -->
          <v-card-text class="pa-6" data-testid="reports-analytics-performance-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Esta serie no tiene un productor canónico y fue retirada en P13-V5A-R5. La medición
              del rendimiento de generación de reportes no está disponible.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" lg="4">
        <v-card elevation="4" class="h-100">
          <v-card-title class="pa-6">
            <v-icon color="warning" class="mr-3">mdi-target</v-icon>
            <span class="text-h5">KPIs Clave</span>
          </v-card-title>

          <!--
            P13-V5A-R5 · RETIRED. Los cuatro KPIs eran un array literal, completo con valor
            actual, meta, progreso y veredicto: "Tiempo de Generación" 2.1s, "Tasa de Éxito"
            98.7 %, "Satisfacción Usuario" 4.8/5 y "Eficiencia Sistema" 94.2 %, todos rotulados
            "Excelente", "Óptimo", "Muy Bueno" y "Bueno". Nada de esto se calculaba: la
            satisfacción de usuario, en particular, no se recoge en ninguna parte del producto.
            El corredor canónico de KPIs es /api/analytics/kpis (R3) y no publica estas
            magnitudes.
          -->
          <v-card-text class="pa-6" data-testid="reports-analytics-kpis-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Estos KPIs no tienen un productor canónico y fueron retirados en P13-V5A-R5. Los
              indicadores con respaldo real se publican en la analítica de incidencias.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- 🔍 USAGE PATTERNS -->
    <v-row class="mb-6">
      <v-col cols="12" md="6">
        <v-card elevation="4">
          <v-card-title class="pa-6">
            <v-icon color="info" class="mr-3">mdi-clock-time-four</v-icon>
            <span class="text-h5">Patrones de Uso</span>
          </v-card-title>

          <!--
            P13-V5A-R5 · RETIRED. El donut repartía el uso entre cinco reportes con porcentajes
            fijos (35 / 25 / 18 / 15 / 7) escritos en el archivo. No hay telemetría de uso de
            reportes en el backend: la distribución no medía nada.
          -->
          <v-card-text class="pa-6" data-testid="reports-analytics-usage-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Esta distribución no tiene un productor canónico y fue retirada en P13-V5A-R5. El
              registro de uso de reportes no está disponible.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card elevation="4">
          <v-card-title class="pa-6">
            <v-icon color="success" class="mr-3">mdi-trophy</v-icon>
            <span class="text-h5">Top Reportes</span>
          </v-card-title>

          <!--
            P13-V5A-R5 · RETIRED. El ranking era un array literal de cinco reportes con número
            de usos (847, 623, 445, 378, 312) y "score" (98, 94, 91, 89, 86), presentado con
            medallas de oro, plata y bronce. Ni los usos ni el score se contaban en ninguna
            parte: no existe productor de uso por reporte.
          -->
          <v-card-text class="pa-6" data-testid="reports-analytics-top-reports-retired">
            <v-alert type="info" variant="tonal" density="compact">
              Este ranking no tiene un productor canónico y fue retirado en P13-V5A-R5. El conteo
              de uso por reporte no está disponible.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- 🤖 PREDICTIVE ANALYTICS -->
    <v-card elevation="4" class="mb-6">
      <v-card-title class="pa-6 bg-gradient-purple text-white">
        <v-icon class="mr-3">mdi-crystal-ball</v-icon>
        <span class="text-h5">Análisis Predictivo</span>
      </v-card-title>

      <!--
        P13-V5A-R5 · RETIRED. Esta sección era la afirmación más fuerte de la pantalla: un
        gráfico que separaba "Datos Históricos" de una "Predicción IA" en línea discontinua
        (ambas series literales), y tres predicciones con porcentaje de confianza —87 %, 92 % y
        78 %— que daban apariencia de modelo calibrado a un texto escrito a mano. El chip "IA
        Avanzada" del encabezado y el botón "Aplicar" de cada predicción completaban la escena.
        No hay ni hubo modelo: R4 eliminó del backend los montajes /api/ai y /api/ml, y
        /api/analytics/ai-predictions responde 501. Una confianza inventada es peor que la
        ausencia de predicción, porque invita a decidir sobre ella.
      -->
      <v-card-text class="pa-6" data-testid="reports-analytics-predictions-retired">
        <v-alert type="info" variant="tonal" density="compact">
          Estas predicciones no tienen un productor canónico y fueron retiradas en P13-V5A-R5. El
          análisis predictivo no está disponible.
        </v-alert>
      </v-card-text>
    </v-card>

    <!-- 📈 TREND ANALYSIS -->
    <v-card elevation="4">
      <v-card-title class="pa-6">
        <v-icon color="orange" class="mr-3">mdi-trending-up</v-icon>
        <span class="text-h5">Análisis de Tendencias</span>
      </v-card-title>

      <!--
        P13-V5A-R5 · RETIRED. Las cuatro tarjetas de tendencia eran un array literal
        —"Velocidad" 2.1s (-12 %), "Volumen" 847 reportes/día (+23 %), "Calidad" 4.8 (+0.3) y
        "Adopción" 156 usuarios (+18 %)— con barras de progreso igualmente fijas. El menú
        "Configurar" ofrecía además alertas sobre esas tendencias y su exportación: configurar
        una alerta sobre una cifra inventada, o exportarla, propaga la falsedad fuera de la
        pantalla, así que el menú se retira con las tarjetas.
      -->
      <v-card-text class="pa-6" data-testid="reports-analytics-trends-retired">
        <v-alert type="info" variant="tonal" density="compact">
          Estas tendencias no tienen un productor canónico y fueron retiradas en P13-V5A-R5. Las
          tendencias con respaldo real se publican en la analítica de incidencias.
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
// P13-V5A-R5 · RETIRED. Este componente no tenía ni un solo consumidor: no importaba cliente
// HTTP alguno y todo su estado era literal. Con las tarjetas desaparecen `aiInsights`,
// `keyKPIs`, `topReports`, `predictions` y `trends`; las tres instancias de Chart.js
// (`performanceChartInstance`, `usageChartInstance`, `predictionChartInstance`) con sus
// constructores `createPerformanceChart()`, `createUsageChart()` y `createPredictionChart()` y
// las referencias a sus canvas; `performancePeriod` y su watch; y los manejadores
// `refreshAnalytics()`, `exportAnalytics()`, `applyPrediction()`, `configureTrends()`,
// `exportTrends()` y `getRankClass()`, que sólo escribían en la consola. Quedan sin uso y se
// eliminan las importaciones de `vue` y de `chart.js/auto`.
</script>

<style scoped lang="scss">
.reports-analytics {
  .analytics-header {
    border-radius: 16px;
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  }

  .bg-gradient-purple {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
}
</style>
